<template>
    <div class="container-fluid ps-0">
        <div class="page-title">
            <div class="row">
                <div class="col-sm-6 d-flex align-items-center">
                    <button v-if="modal" class="btn btn-info" type="button" data-bs-toggle="modal"
                        data-original-title="test" :data-bs-target="'#' + modal" :disabled="disabled">New</button>
                    <button v-if="buttonLabel" class="btn btn-primary" @click="$emit('buttonClick')" :disabled="disabled">
                        {{ buttonLabel }}
                    </button>
                </div>
                <div class="col-sm-6">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item"><router-link to="/"><vue-feather
                                    type="home"></vue-feather></router-link></li>
                        <li class="breadcrumb-item" v-if="main">{{ main }}</li>
                        <li class="breadcrumb-item active" v-if="title">{{ title }}</li>
                    </ol>
                </div>
            </div>
        </div>
    </div>
</template>
<script lang="ts" setup>
let props = defineProps({
    title: {
        default: 'home'
    },
    main: {
        default: ''
    },
    modal: {
        default: ''
    },
    rout: {
        default: ''
    },
    buttonLabel: {
        default: ''
    },
    disabled: {
        type: Boolean,
        default: false
    }
})
</script>

<style scoped>
button {
    background-color: var(--orchit-primary) !important;
    border-color: var(--orchit-primary) !important;
    font-family: var(--orchit-font);
    font-weight: 600;
}
button:active{
    background-color: var(--orchit-primary-dark) !important;
    color: #fff !important;
}
</style>